// Role helpers for tenant-dashboard UX gating (backend remains the source of truth).
// Mirrors the localStorage pattern used by MaintenanceGuard's isSuperAdmin.

export const userRoles = (): string[] => {
  try {
    const stored = localStorage.getItem("user_info");
    if (!stored) return [];
    const user = JSON.parse(stored);
    return Array.isArray(user?.roles) ? user.roles : [];
  } catch {
    return [];
  }
};

export const hasRole = (r: string): boolean => userRoles().includes(r);

// Org-user management is backend-gated to admin/org-admin; org-viewer must NOT
// see these controls.
export const canManageOrgUsers = (): boolean =>
  hasRole("admin") || hasRole("org-admin");
